import { create } from 'zustand';
import { syncService, type SyncContext } from '@/services/sync';

type Status = 'idle' | 'syncing' | 'success' | 'failure';

interface SyncState {
  status: Status;
  lastError: string | null;
  newCount: number;
  modifiedCount: number;
  lastContext: SyncContext | null;
}

export const useSyncStore = create<SyncState>(() => ({
  status: 'idle',
  lastError: null,
  newCount: 0,
  modifiedCount: 0,
  lastContext: null,
}));

syncService.subscribe(({ status, error, newCount, modifiedCount, context }) => {
  if (status === 'started') {
    useSyncStore.setState({ status: 'syncing', lastError: null, lastContext: context });
  } else if (status === 'success') {
    useSyncStore.setState({
      status: 'success',
      newCount: newCount ?? 0,
      modifiedCount: modifiedCount ?? 0,
      lastContext: context,
    });
  } else if (status === 'failure') {
    useSyncStore.setState({
      status: 'failure',
      lastError: (error as Error)?.message ?? 'sync failed',
      lastContext: context,
    });
  }
});
